export const mapAllPlaylistVideos = playlists =>
	playlists.reduce(
		(allVideos, playlist) => ({
			...allVideos,
			...playlist.videos.reduce((res, curVideo) => ({ ...res, [curVideo.videoId]: curVideo }), {})
		}),
		{}
	);

export const mapAllPlaylistFilter = playlists => {
	const defaultFilter = { id: 'all', title: 'All Playlists', itemCount: 0 };
	defaultFilter.itemCount = playlists.reduce((total, playlist) => total + playlist.itemCount, 0);

	const playlistWithTitles = playlists?.map(({ id, title, itemCount }) => ({ id, title, itemCount })) || [];
	playlistWithTitles.unshift(defaultFilter);
	return playlistWithTitles;
};

export const getLocalStorageValue = key => {
	let cacheData = localStorage.getItem(key);
	return cacheData && JSON.parse(cacheData);
};

export const filterPlaylistVideos = (playlist, searchText) => {
	const videos = playlist.videos.filter(
		video => video.title.toLowerCase().includes(searchText) || video.description.toLowerCase().includes(searchText)
	);
	return { ...playlist, videos };
};
